import React from 'react';
/** @jsx jsx */
import { Global, jsx, css } from '@emotion/core';
import { marketingMobileCuttoff, darkBackground } from '@css/constants';

const styles = css`
  html {
    background-color: ${darkBackground};

    @media(max-width: ${marketingMobileCuttoff}) {
      background-color: white;
    }
  }
`;

export const DarkBackground = () => (
  <Global styles={styles} />
);
